var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrontViewDashed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg6167",
    viewBox: "0 0 236.299 386.412",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs5783"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style5781"
  }, ".a{fill:#2f7dac}"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-285.078 -148.976)",
    id: "g6165",
    style: {
      opacity: 1,
      stroke: "#fff",
      strokeOpacity: 1,
      strokeWidth: 3,
      strokeMiterlimit: 4,
      strokeDasharray: "9,3",
      strokeDashoffset: 0
    }
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(286.555 144.598)",
    id: "g6147",
    style: {
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 3,
      strokeMiterlimit: 4,
      strokeDasharray: "9,3",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M468 448.091c.037-1.3-.1-2.415-.088-3.065.012-.65.311-4.906.223-7.251l10.181.284s.1 6.736.123 7.273c.023.537 10.333 7.83 10.716 8.477 4.325 7.3-12.243 15.303-14.269 14.07-2.168-.72-4.92-8.395-7.238-9.923-.731-.484.321-8.61.352-9.865z",
    transform: "translate(-334.666 -78.865)",
    id: "path5833",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 3,
      strokeMiterlimit: 4,
      strokeDasharray: "9,3",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M427.625 448.107c-.028-1.3.118-2.414.106-3.064-.012-.65-.285-4.909-.184-7.253l-10.182.228s-.134 6.735-.163 7.272c-.029.537-16.477 13.274-16.864 13.92-4.364 7.278 18.257 9.866 20.294 8.647 2.171-.708 4.966-8.368 7.292-9.884.736-.479-.27-8.611-.299-9.866z",
    transform: "translate(-327.339 -78.868)",
    id: "path5835",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 3,
      strokeMiterlimit: 4,
      strokeDasharray: "9,3",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M444.258 98.679s6.986-3.473 6.986-1.95c0 3.5 5.074 5.044 6.792 5.478 1.718.434 13.114.554 17.2 4.467 0 0-3.438 15.357-4.571 24.366-.087.7.94 3.745.275 8.316-2.052 15.92 1.82 47.629 4.856 63.462l.365 4.268-64.47.23c3.037-15.833 11.264-50.983 5.882-67.96-.665-4.57.362-7.62.274-8.316-1.133-9.009-4.566-24.366-4.566-24.366 4.086-3.913 15.478-4.032 17.196-4.467 1.718-.435 6.792-1.982 6.792-5.478.003-1.523 6.989 1.95 6.989 1.95z",
    transform: "translate(-326.98 -31.746)",
    id: "path5837",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 3,
      strokeMiterlimit: 4,
      strokeDasharray: "9,3",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M486.885 113.574c5.278 5.211 2.665 11.665 4.891 14.314 15.992 19.035 22.437 34.038 26.9 40.57 1.652 2.417 5.45 5.525 8.729 9.06 15.251 16.439 18.248 25.075 24.698 31.111 0 0-4.62 4.435-5.737 3.455-7.511-6.576-21.67-16.591-31.167-30.349-3.177-4.6-7.74-8.722-9-10.109-9.844-10.677-11.511-12.084-19.216-24.393-3.708-4.916-3.998-6.06-3.188-11.546-.6-1.567 1.896-20.521 3.09-22.113z",
    transform: "translate(-333.826 -33.4)",
    id: "path6027",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 3,
      strokeMiterlimit: 4,
      strokeDasharray: "9,3",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M396.088 115.05c-5.278 5.211-1.84 10.189-4.066 12.838-15.993 19.035-22.437 34.038-26.9 40.57-1.652 2.417-5.45 5.525-8.729 9.06-15.252 16.439-17.52 22.09-23.97 28.125 0 0 5.503 7.047 6.62 6.07 7.512-6.577 20.059-16.22 29.556-29.978 3.176-4.6 7.74-8.722 9-10.109 9.844-10.677 2.181-1.745 9.886-14.055 3.709-4.916-3.51-.571 12.9-14.651.73-15.915-4.297-27.87-4.297-27.87z",
    transform: "translate(-315.415 -33.4)",
    id: "path6029",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 3,
      strokeMiterlimit: 4,
      strokeDasharray: "9,3",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M478.089 236.137c3.926 22.15-1.9 51.726-3.754 60.416-2.916 13.659-3.114 24.5-3.472 30.47-.061 1.022.761 7.352 2.076 21.559 1.893 20.461-2.497 28.992-1.702 51.746-3.108 1.815-9.284 1.29-12.543-.239-.291-.351 1.476-5.165-1.285-19.238-4.2-21.39-5.409-38.374-4.431-50.1.08-3.132-.274-6.26-1.052-9.295-2.635-12.7-3.758-30.927-4.724-44.924-.806-11.686-2.014-14.834-2.27-22.866-.092-2.9.05-2.342-1.233-2.342-1.831 0-.974-.022-1.023 2.176-.177 8.035-1.771 11.435-2.64 23.117-1.041 13.991-2.264 32.21-4.969 44.9a33.968 33.968 0 0 0-1.1 9.289c.913 11.735-.392 28.712-4.706 50.079-2.837 14.058-.44 17.924-2.282 19.885-3.267 1.51-7.637.713-10.735-1.119.919-22.75-4.34-30.669-2.336-51.119 1.392-14.2 2.249-20.525 2.194-21.548-.327-5.968-.465-16.813-3.307-30.488-1.808-8.7-8.057-38.71-3.581-60.755.571-2.814 68.374-2.432 68.875.396z",
    transform: "translate(-326.418 -48.791)",
    id: "path6035",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 3,
      strokeMiterlimit: 4,
      strokeDasharray: "9,3",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M446.418 28.236c14.613.148 20.233 14.275 18.878 27.585-.948 9.316-1.583 12.843-5.668 17.026-5.124 5.249-7.8 8.381-13.209 8.454-5.408-.072-8.085-3.2-13.209-8.454-4.084-4.183-4.719-7.71-5.668-17.026-1.356-13.31 4.263-27.437 18.876-27.585z",
    transform: "translate(-329.14 -22.346)",
    id: "path6133",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 3,
      strokeMiterlimit: 4,
      strokeDasharray: "9,3",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m576.386 235.988 4.126 8.07-1.327 6.224-4.617.842-.882 3.382-2.265.717-1.436-4.467-5.227-8.835s-.3-5.564-.547-6.33c-.247-.766-.164-2.69-.164-2.69l5.191-4.851z",
    transform: "translate(-347.167 -48.791)",
    id: "path6137",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 3,
      strokeMiterlimit: 4,
      strokeDasharray: "9,3",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m317.543 235.988-4.126 8.07 1.327 6.224 4.618.842.881 3.382 2.266.717 1.435-4.467 5.227-8.835s.3-5.564.547-6.33c.247-.766 2.353-2.86 2.353-2.86l-6.169-6.405z",
    transform: "translate(-313.417 -48.791)",
    id: "path6139",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#fff",
      strokeWidth: 3,
      strokeMiterlimit: 4,
      strokeDasharray: "9,3",
      strokeDashoffset: 0,
      strokeOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontViewDashed);
export default __webpack_public_path__ + "static/media/front-view-dashed.90f892be3f88614450b9eca6d9d79422.svg";
export { ForwardRef as ReactComponent };